/* ============================================================
   GIANELI - GRUPOS DO CARRINHO
   assets/gianeli-grupos.js

   Impede que um extra fique no carrinho sem a peca a que
   pertence.

   O PROBLEMA
   Cada charm, gravacao ou extra e' uma linha propria do
   carrinho, porque so' assim a Shopify os sabe cobrar. Mas o
   cliente que remova a peca fica com os acessorios la' dentro e
   paga 24 EUR de contas sem peca nenhuma. Isso nunca pode
   chegar a acontecer.

   COMO SE RESOLVE
   Todas as linhas do mesmo pedido levam a propriedade _gd_grupo
   com o mesmo codigo. As linhas dos extras levam tambem
   _gd_para, com o nome da peca. Portanto:

     linha com _gd_grupo e SEM _gd_para  ->  e' a peca
     linha com _gd_grupo e COM _gd_para  ->  e' um extra

   Se um grupo tiver extras e nao tiver peca, os extras estao
   orfaos e saem.

   PORQUE E' FEITO NO NAVEGADOR
   Porque nao ha outro sitio. Sem Shopify Plus nao se corre
   codigo nosso do lado da Shopify, e as apps que o fariam sao a
   Easify e companhia — que e' de quem estamos a fugir.

   Nao e' a prova de tudo: alguem com o JavaScript desligado
   podia remover a peca e ficar com os extras. Para esse caso
   raro fica a encomenda com _gd_para escrito, que diz a equipa
   exactamente o que aconteceu.
   20/10/2026: tambem trata do REMOVE dos charms, extras e pacote
   que aparecem como produtos proprios (ver mais abaixo).
   01/11/2026: LINHAS CLEAN (pintarClean, so aspeto): por baixo da
   peca, o diamante da Gianeli transparente em vez da foto e o nome
   em cinzento claro, alinhados; o REMOVE sem sublinhado.
   ============================================================ */

(function () {
  'use strict';

  var aVerificar = false;

  /* 15/10/2026: TODOS OS PEDIDOS COM A LINGUA DA LOJA (/es/, /fr/...).
     Antes o carrinho era pedido sem a lingua, e a Shopify devolvia-o
     em ingles: ao remover uma peca, a gaveta e o "Continue shopping"
     passavam para ingles. */
  function raiz() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* ---------- O CERTINHO DOS EXTRAS ----------
     Os charms tem fotografia na loja e ficam com a miniatura. A
     proteccao de envio, a revisao do design e a gravacao no verso
     nao tem fotografia, e um quadrado cinzento vazio nao diz nada
     a ninguem.

     v2 - MAIS LEVE
     Antes era um quadrado cheio de verde com o certinho branco,
     pesado ao lado das miniaturas transparentes dos charms. Agora
     o quadrado fica transparente, como o dos charms, e no centro
     aparece so' um circulo fino com o certinho no verde da marca.

     v3 - UMA LISTA SO', A VISTA DO CLIENTE
     Por baixo da peca ha' duas listas, feitas por sitios
     diferentes:
       - .gianeli-extras: o que e' gratis e vai como propriedade
         da propria peca (a gravacao na frente). Desenhada pelo
         carrinho do tema, com um ✓ de texto.
       - .gianeli-group-items: o que tem linha propria no carrinho
         (charms, revisao, gravacao no verso). Desenhada aqui.
     Cada uma trazia o seu espacamento e a sua linha, e o cliente
     via a gravacao na frente separada do resto por um traco, com
     um certinho diferente. Estas regras tiram o traco, encostam
     as duas listas e poem o mesmo circulo nas duas.

     PORQUE E' QUE ISTO ESTA AQUI E NAO NO cart-products.liquid
     Porque assim nao e' preciso voltar a mexer num ficheiro de
     1900 linhas por causa de dez linhas de estilo. O :empty so' e'
     verdadeiro quando nao ha mesmo nada la dentro, por isso as
     miniaturas com fotografia nunca sao tocadas.

     v4 - ALINHADAS AO MILIMETRO
     O circulo e o texto da gravacao na frente ficavam um pouco
     acima e mais a esquerda que os das outras linhas. A linha
     passa a centrar na vertical, como as outras, e o alinhamento
     na horizontal e' feito pelo alinharListas(), mais abaixo.

     A folha e' escrita uma unica vez, mesmo que o carrinho seja
     redesenhado vinte vezes. O id muda a cada versao para a
     antiga, se ficar em cache, nao se sobrepor a esta. */

  function pintarCertinhos() {
    if (document.getElementById('gianeli-grupos-estilo-v4')) return;

    ['gianeli-grupos-estilo', 'gianeli-grupos-estilo-v2', 'gianeli-grupos-estilo-v3'].forEach(function (id) {
      var antigo = document.getElementById(id);
      if (antigo) antigo.remove();
    });

    var circulo =
      'content:"\\2713";' +
      'display:flex;align-items:center;justify-content:center;' +
      'box-sizing:border-box;width:14px;height:14px;' +
      'border:1px solid #00221b;border-radius:50%;' +
      'color:#00221b;font-size:8px;line-height:1;font-weight:600;';

    var estilo = document.createElement('style');
    estilo.id = 'gianeli-grupos-estilo-v4';
    estilo.textContent =
      /* O circulo das linhas sem fotografia. */
      '.gianeli-group-row__media:empty{' +
      'display:flex;align-items:center;justify-content:center;' +
      'background:transparent;}' +
      '.gianeli-group-row__media:empty::after{' + circulo + '}' +

      /* Sem traco nem folga entre as duas listas. */
      '.gianeli-extras-cell .gianeli-extras{' +
      'margin-bottom:0!important;padding-bottom:0!important;' +
      'border-bottom:0!important;}' +
      '.gianeli-extras-cell .gianeli-group-items{' +
      'margin-top:6px!important;padding-top:0!important;' +
      'border-top:0!important;}' +
      '.gianeli-extras-cell .gianeli-group-items::before,' +
      '.gianeli-extras-cell .gianeli-extras::after{' +
      'display:none!important;content:none!important;}' +

      /* O mesmo circulo na gravacao na frente. O ✓ de texto que
         o tema la' poe fica invisivel (tamanho zero) e o circulo
         desenha-se por cima, no mesmo sitio. */
      '.gianeli-extras-cell .cart-item__extra-check{' +
      'display:inline-flex;align-items:center;justify-content:center;' +
      'flex:0 0 auto;font-size:0!important;line-height:0;}' +
      '.gianeli-extras-cell .cart-item__extra-check::after{' + circulo + '}' +

      /* A linha da frente centra na vertical, como as outras. */
      '.gianeli-extras-cell .gianeli-extras .cart-item__extra-row{' +
      'align-items:center!important;}';

    document.head.appendChild(estilo);
  }

  /* ---------- 01/11/2026: LINHAS CLEAN ----------
     So aspeto. As linhas por baixo da peca (corrente, verso,
     charms, extras) passam a ter o diamante da Gianeli
     (desenhado no snippets/cart-products-extras.liquid) no lugar
     da foto, transparente e do tamanho da letra, e o nome numa
     linha so' em cinzento claro. A gravacao na frente (a outra
     lista) leva o mesmo diamante no lugar do certinho. O REMOVE
     da peca fica sem sublinhado. */
  function pintarClean() {
    if (document.getElementById('gianeli-grupos-clean-v5')) return;
    var diamante =
      "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2314181a' stroke-opacity='.5' stroke-width='1.4' stroke-linejoin='round' stroke-linecap='round'%3E%3Cpath d='M6.5 3.5h11l4 5.2L12 20.5 2.5 8.7z'/%3E%3Cpath d='M2.5 8.7h19M9.2 3.5 7.6 8.7 12 20.5 16.4 8.7 14.8 3.5M7.6 8.7 12 3.6l4.4 5.1'/%3E%3C/svg%3E\")";
    var estilo = document.createElement('style');
    estilo.id = 'gianeli-grupos-clean-v5';
    estilo.textContent =
      /* A caixa da foto: sem fundo, so' o diamante ao centro. */
      '.gianeli-group-row__media.gianeli-group-row__media--diamante{' +
      'display:flex!important;align-items:center;justify-content:center;' +
      'background:none!important;border:0!important;box-shadow:none!important;border-radius:0!important;overflow:visible!important;margin-top:0!important;}' +
      '.gianeli-group-row__diamante{display:block;width:11px!important;height:11px!important;' +
      'fill:none!important;stroke:#14181a!important;stroke-opacity:.5!important;stroke-width:1.4!important;stroke-linejoin:round;stroke-linecap:round;}' +
      '.gianeli-group-row__diamante path{fill:none!important;}' +
      '.gianeli-group-items .gianeli-group-row.gianeli-group-row--clean{align-items:center!important;gap:5px!important;}' +
      '.gianeli-group-items .gianeli-group-row--clean .gianeli-group-row__media{flex:0 0 11px!important;width:11px!important;height:11px!important;margin:0!important;justify-content:flex-start!important;}' +
      '.gianeli-group-row--clean .gianeli-group-row__info{justify-content:flex-start!important;text-align:left!important;min-height:0!important;}' +
      '.gianeli-group-row--clean .gianeli-group-row__price{align-self:center!important;padding-top:0!important;}' +
      /* O nome numa linha, em cinzento claro. */
      '.gianeli-group-row--clean .gianeli-group-row__nome{' +
      'color:rgb(20 24 26 / .5)!important;font-weight:400!important;font-size:9.5px!important;line-height:11px!important;' +
      'white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}' +
      /* A gravacao na frente: o mesmo diamante no lugar do certinho. */
      '.gianeli-extras-cell .cart-item__extra-check::after{' +
      'content:""!important;width:11px!important;height:11px!important;border:0!important;' +
      'border-radius:0!important;background:' + diamante + ' center/11px 11px no-repeat!important;}' +
      '.gianeli-extras-cell .cart-item__extra-name{color:rgb(20 24 26 / .5)!important;}' +
      /* O REMOVE da peca sem sublinhado. */
      '.gianeli-remove,.gianeli-remove:hover{text-decoration:none!important;border-bottom:0!important;}';
    document.head.appendChild(estilo);
  }

  /* ---------- ALINHAR AS DUAS LISTAS ----------
     As linhas com linha propria (charms, revisao, verso) tem uma
     caixa para a miniatura com uma largura e um espaco que vem do
     CSS do carrinho. Em vez de adivinhar esses numeros e ter de os
     acertar a mao sempre que o tema mudar, mede-se uma dessas
     linhas no proprio ecra e poe-se o certinho da gravacao na
     frente exactamente no mesmo sitio: mesma largura, mesma
     distancia a margem, texto a comecar na mesma coluna.

     Se o carrinho nao tiver nenhuma linha dessas, nao ha' nada com
     que alinhar e fica como o tema o desenha.

     Corre sempre que o carrinho e' redesenhado, porque cada
     redesenho traz linhas novas, sem os acertos da vez anterior. */

  function alinharListas() {
    var modelo = document.querySelector(
      '.gianeli-extras-cell .gianeli-group-row'
    );
    if (!modelo) return;

    var caixa = modelo.querySelector('.gianeli-group-row__media');
    var info = modelo.querySelector('.gianeli-group-row__info');
    if (!caixa || !info) return;

    var rLinha = modelo.getBoundingClientRect();
    var rCaixa = caixa.getBoundingClientRect();
    var rInfo = info.getBoundingClientRect();
    if (!rCaixa.width) return;

    var inicioCaixa = rCaixa.left - rLinha.left;
    var inicioTexto = rInfo.left - rLinha.left;

    document
      .querySelectorAll('.gianeli-extras-cell .gianeli-extras .cart-item__extra-row')
      .forEach(function (linha) {
        var certo = linha.querySelector('.cart-item__extra-check');
        if (!certo) return;

        /* A diferenca entre esta lista e a outra, se as margens
           das duas nao coincidirem. */
        var desvio = linha.getBoundingClientRect().left - rLinha.left;

        linha.style.gap = '0px';
        linha.style.columnGap = '0px';

        certo.style.width = rCaixa.width + 'px';
        certo.style.minWidth = rCaixa.width + 'px';
        certo.style.marginLeft = Math.max(0, inicioCaixa - desvio) + 'px';
        certo.style.marginRight =
          Math.max(0, inicioTexto - inicioCaixa - rCaixa.width) + 'px';
      });
  }

  /* O carrinho e' redesenhado por varios sitios (o tema, o painel,
     este ficheiro), e nenhum avisa. Um observador fica a espera de
     linhas novas e realinha - uma vez por quadro, no maximo, para
     nao pesar. */
  var alinharPedido = false;

  function pedirAlinhamento() {
    if (alinharPedido) return;
    alinharPedido = true;
    requestAnimationFrame(function () {
      alinharPedido = false;
      alinharListas();
    });
  }

  function vigiarCarrinho() {
    if (!window.MutationObserver || !document.body) return;
    new MutationObserver(function (mudancas) {
      for (var i = 0; i < mudancas.length; i++) {
        if (mudancas[i].addedNodes && mudancas[i].addedNodes.length) {
          pedirAlinhamento();
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });

    /* A gaveta fechada tem tudo com largura zero; so' se consegue
       medir quando abre ou quando o ecra muda de tamanho. */
    document.addEventListener('click', function () {
      setTimeout(pedirAlinhamento, 350);
    });
    window.addEventListener('resize', pedirAlinhamento);
  }

  /* ---------- LER O CARRINHO ---------- */

  function carrinho() {
    return fetch(raiz() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  /* ---------- ENCONTRAR OS ORFAOS ---------- */

  function orfaos(cart) {
    if (!cart || !cart.items) return [];

    var pecas = {};
    var extras = [];

    cart.items.forEach(function (item) {
      var props = item.properties || {};
      var grupo = props._gd_grupo;
      if (!grupo) return;

      if (props._gd_para) {
        extras.push({ key: item.key, grupo: grupo });
      } else {
        pecas[grupo] = true;
      }
    });

    return extras
      .filter(function (e) {
        return !pecas[e.grupo];
      })
      .map(function (e) {
        return e.key;
      });
  }

  /* ---------- REMOVER ----------
     Todos de uma vez, num pedido so'. Um a um, o carrinho
     redesenhava-se entre cada remocao e o cliente via as linhas
     a desaparecer aos saltos. */

  function remover(chaves) {
    var updates = {};
    chaves.forEach(function (chave) {
      updates[chave] = 0;
    });

    return fetch(raiz() + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) {
        return r.ok;
      })
      .catch(function () {
        return false;
      });
  }

  /* ---------- REDESENHAR A GAVETA ----------
     Sem isto as linhas continuavam a ver-se ate' o cliente
     recarregar a pagina, mesmo ja' nao existindo no carrinho.

     E' PRECISO REABRIR A GAVETA A SEGUIR
     Trocar o HTML da seccao destroi o <dialog> que esta' aberto, e
     o cliente e' atirado para a pagina que estava por tras — no
     nosso caso, a pagina de personalizacao. Por isso guarda-se
     antes se ela estava aberta, e reabre-se depois de o HTML novo
     entrar. O <theme-drawer> acabou de nascer, por isso espera-se
     que o navegador o reconheca. */

  function gavetaAberta() {
    var gaveta = document.getElementById('cart-drawer');
    if (!gaveta) return false;
    if (gaveta.hasAttribute('open')) return true;
    if (gaveta.isOpen) return true;

    var dialogo = gaveta.querySelector('dialog');
    return !!(dialogo && dialogo.open);
  }

  function reabrir() {
    function tenta() {
      var gaveta = document.getElementById('cart-drawer');
      if (gaveta && typeof gaveta.open === 'function') {
        gaveta.open();
        return true;
      }
      return false;
    }

    if (tenta()) return;

    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('theme-drawer').then(function () {
        requestAnimationFrame(tenta);
      });
    }
  }

  function redesenhar() {
    /* 19/10/2026: NA PAGINA /cart RECARREGA A PAGINA.
       A pagina do carrinho nao e' a gaveta: o HTML da gaveta nao a
       atualiza. Sem isto, depois de remover a peca, os extras
       saiam do carrinho mas a pagina continuava a dizer "Carrinho 3"
       com o preco do charm, ate' o cliente carregar noutra coisa.
       Recarregando, aparece logo o carrinho certo (ou o vazio). */
    if (document.querySelector('.cart-page')) {
      window.location.reload();
      return Promise.resolve();
    }

    var estavaAberta = gavetaAberta();

    return fetch(raiz() + '?sections=cart-drawer-section', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (seccoes) {
        var html = seccoes ? seccoes['cart-drawer-section'] : null;
        var caixa = document.getElementById(
          'shopify-section-cart-drawer-section'
        );
        if (!html || !caixa) return;

        caixa.outerHTML = html;

        /* Se o carrinho ficou vazio, nao vale a pena reabrir uma
           gaveta so' para mostrar um vazio ao cliente que acabou
           de remover tudo de proposito. */
        if (estavaAberta) reabrir();
      })
      .catch(function () {});
  }

  /* ---------- A BOLINHA DO CARRINHO NO CABECALHO ----------
     19/10/2026. Depois de os extras sairem, o carrinho fica com
     menos coisas, mas a bolinha do cabecalho ficava com o numero
     antigo (ex.: 2 com o carrinho vazio) ate' ao F5.
     Aqui pede-se ao PROPRIO icone do tema que se atualize, com a
     funcao que ele usa quando se adiciona ou remove um produto.
     Nao se desenha nem esconde nada a mao: se o tema nao tiver
     essa funcao, nao acontece nada. */
  /* 27/10/2026: A BOLINHA CONTA PECAS. Antes recebia o
     item_count (todas as linhas): com a corrente e um extra gratis
     de uma peca ja' removida, mostrava "2" — e o numero ficava
     guardado e voltava depois do F5. Agora conta so' as linhas sem
     _gd_para (as pecas; a Bolsa de regalo conta 1), como o
     cart-icon.js, o cart-bubble.liquid e a gaveta. Sem pecas = 0. */
  function pecasDe(cart) {
    if (!cart || !cart.items) return 0;
    var n = 0;
    cart.items.forEach(function (item) {
      var p = item.properties || {};
      if (!p._gd_para) n += item.quantity || 0;
    });
    return n;
  }

  function acertarBolinha(n) {
    document.querySelectorAll('cart-icon').forEach(function (icone) {
      if (typeof icone.renderCartBubble !== 'function') return;
      try {
        icone.renderCartBubble(n, false, false);
      } catch (e) {}
    });
  }

  /* ---------- A VERIFICACAO ---------- */

  function verificar() {
    if (aVerificar) return;
    aVerificar = true;

    carrinho()
      .then(function (cart) {
        var chaves = orfaos(cart);
        if (!chaves.length) return null;
        return remover(chaves)
          .then(carrinho)
          .then(function (novo) {
            if (novo) acertarBolinha(pecasDe(novo));
          })
          .then(redesenhar);
      })
      .then(function () {
        aVerificar = false;
      })
      .catch(function () {
        aVerificar = false;
      });
  }

  /* ---------- QUANDO VERIFICAR ----------
     Ao abrir a pagina, e depois de qualquer clique que possa ter
     removido alguma coisa. Os dois tempos sao para apanhar a
     animacao do tema, que demora a acabar. */

  function comecar() {
    pintarCertinhos();
    pintarClean();
    vigiarCarrinho();
    pedirAlinhamento();
    verificar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', comecar);
  } else {
    comecar();
  }

  document.addEventListener('click', function (evento) {
    var alvo = evento.target;
    if (!alvo || !alvo.closest) return;

    var removeu =
      alvo.closest('.gianeli-remove') ||
      alvo.closest('.cart-items__remove') ||
      alvo.closest('[on\\:click^="/onLineItemRemove"]');

    if (!removeu) return;

    setTimeout(verificar, 500);
    setTimeout(verificar, 1200);
    setTimeout(verificar, 2200);
  });

  /* ---------- REMOVER UM CHARM / EXTRA / PACOTE (20/10/2026) ----------
     Os charms, os extras e o pacote aparecem no carrinho como
     produtos proprios, com REMOVE (botao [data-gianeli-solto] no
     cart-products.liquid). Remover tira SO essa linha: a peca e a
     personalizacao ficam como estavam.

     A seguir acerta-se o texto da peca para a producao: a linha da
     peca guarda "Charms: ..." e "Extras: ..." escritos no momento em
     que foi personalizada. Se o cliente tirou um charm, esse texto
     passa a dizer so o que ficou (ou desaparece, se nao ficou
     nada). Assim a encomenda nunca pede um charm que nao foi pago. */

  function eurosTexto(c) {
    c = Math.round(c || 0);
    if (c % 100 === 0) return (c / 100) + '\u20AC';
    return (c / 100).toFixed(2).replace('.', ',') + '\u20AC';
  }

  function nomeLinha(item) {
    var nome = item.product_title || item.title || '';
    var v = item.variant_title;
    if (v && v !== 'Default Title' && nome.indexOf(v) === -1) nome += ' - ' + v;
    return nome.replace(/[()]/g, '') + ' (' + eurosTexto(item.final_line_price) + ')';
  }

  function acertarTextoDaPeca(cart, grupo, tipo) {
    if (!cart || !cart.items || !grupo) return Promise.resolve();
    var chave = tipo === 'conta' ? 'Charms' : 'Extras';
    var peca = null;
    var ficam = [];
    cart.items.forEach(function (item) {
      var p = item.properties || {};
      if (p._gd_grupo !== grupo) return;
      if (!p._gd_para) { peca = item; return; }
      var t = p._gd_tipo;
      if (chave === 'Charms' && t === 'conta') ficam.push(nomeLinha(item));
      if (chave === 'Extras' && (t === 'extra' || t === 'pacote')) ficam.push(nomeLinha(item));
    });
    if (!peca) return Promise.resolve();

    var props = {};
    var antes = peca.properties || {};
    Object.keys(antes).forEach(function (k) {
      if (antes[k] !== null && antes[k] !== undefined) props[k] = antes[k];
    });
    if (!(chave in props) && !ficam.length) return Promise.resolve();
    if (ficam.length) props[chave] = ficam.join(', ');
    else delete props[chave];

    return fetch(raiz() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: peca.key, quantity: peca.quantity, properties: props })
    }).catch(function () {});
  }

  var aTirarSolto = false;

  document.addEventListener('click', function (evento) {
    var alvo = evento.target;
    var botao = alvo && alvo.closest && alvo.closest('[data-gianeli-solto]');
    if (!botao) return;
    evento.preventDefault();
    evento.stopPropagation();
    if (aTirarSolto) return;
    aTirarSolto = true;

    var chave = botao.getAttribute('data-gianeli-solto');
    var linha = botao.closest('tr');
    if (linha) linha.classList.add('gianeli-a-sair');

    var grupo = null;
    var tipo = null;

    carrinho()
      .then(function (cart) {
        (cart && cart.items ? cart.items : []).forEach(function (item) {
          if (item.key !== chave) return;
          grupo = (item.properties || {})._gd_grupo || null;
          tipo = (item.properties || {})._gd_tipo || null;
        });
        return remover([chave]);
      })
      .then(carrinho)
      .then(function (novo) {
        return acertarTextoDaPeca(novo, grupo, tipo).then(function () { return novo; });
      })
      .then(function (novo) {
        if (novo) acertarBolinha(pecasDe(novo));
        return redesenhar();
      })
      .then(function () {
        aTirarSolto = false;
      })
      .catch(function () {
        aTirarSolto = false;
        if (linha) linha.classList.remove('gianeli-a-sair');
      });
  }, true);

  /* Voltar atras no navegador devolve o carrinho da cache. */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) verificar();
  });
})();